export default __webpack_public_path__ + "static/media/Devils.4716af89.png";